module.exports = __webpack_public_path__ + "static/img/data3-list2.0d92a705.png";